import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AzaleaLayout } from '../src/azalea/AzaleaLayout';
import { AzaleaLandingPage } from '../src/azalea/AzaleaLandingPage';
import {
  AzaleaPrivacy,
  AzaleaTerms,
  AzaleaFaq,
  AzaleaSupport,
  AzaleaDataRights,
} from '../src/azalea/AzaleaPages';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AzaleaLayout />}>
          <Route index element={<AzaleaLandingPage />} />
          <Route path="privacy" element={<AzaleaPrivacy />} />
          <Route path="terms" element={<AzaleaTerms />} />
          <Route path="faq" element={<AzaleaFaq />} />
          <Route path="support" element={<AzaleaSupport />} />
          <Route path="data-rights" element={<AzaleaDataRights />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
